import React from 'react';
import ButtonGeneral from './ButtonGeneral';

type Props = {
    callbackCreate: () => void;
    title?: string;
    loading?: boolean;
    locked?: boolean;
    message?: string;
};

const ButtonCreate = ({
    callbackCreate,
    title = 'Nuevo',
    loading = false,
    locked = false,
    message = 'No se puede crear un registro.'
}: Props) => {
    return (
        <ButtonGeneral
            onClick={callbackCreate}
            title={title}
            loading={loading}
            locked={locked}
            errorMessage={message}
            variant="outline"
            size="small"
            icon="fa-plus"
        />
    );
};

export default ButtonCreate;
